import { CallAPI } from "../utils/api";

export async function Login(email, password) {
  const data = {
    email: email,
    password: password,
  };
  return CallAPI(
    "/login",
    {
      // credentials: 'include',
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      mode: "cors",
      body: JSON.stringify(data),
    },
    false
  );
}

export async function Signup(fullName, email, password) {
  const data = {
    fullName: fullName,
    email: email,
    password: password,
    role: "user",
  };
  return CallAPI(
    "/register",
    {
      // credentials: 'include',
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      mode: "cors",
      body: JSON.stringify(data),
    },
    false
  )
}

export async function PasswordResetRequest(email) {
  const data = {
    email: email,
  };
  return CallAPI(
    "/passwordResetRequest",
    {
      // credentials: 'include',
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      mode: "cors",
      body: JSON.stringify(data),
    },
    false
  )
}

export async function ResetPasswordSubmit(email, password, token) {
  const data = {
    email: email,
    password: password,
    token: token,
  };
  return CallAPI(
    "/passwordResetSubmit",
    {
      // credentials: 'include',
      method: "PATCH",
      headers: {
        "Content-Type": "application/json"
      },
      mode: "cors",
      body: JSON.stringify(data),
    },
    false
  );
}